<template>
    <div class="animated fadeIn">
      <b-card header-tag="header">
        <div slot="header">
          <i class="fa fa-building"></i> Empresas
          <b-link :to="`/${actionUri}/new/`" class="btn mr-2 btn-sm btn-primary float-right">
            <i class="fa fa-plus"></i>
            Entrada
          </b-link>
        </div>
        <b-card-body>
          <template>
            <div class="form-row justify-content-start">
              <div class="col-md-4">
                <base-input label="Digite o nome da empresa" v-model="searchModel.keywords" v-on:keyup.enter="search" placeholder="" />
              </div>
              <div class="col-md-4">
                <div class="form-group">
                    <label>Representantes</label>
                    <model-list-select :list="searchModel.salesPerson.data"
                        option-value="id"
                        option-text="name"
                        v-model="searchModel.salesPerson.selected"
                        placeholder="Digite o nome do representante"
                        @searchchange="searchSalesPerson">
                    </model-list-select>
                </div>
              </div>                  
            </div>
            <b-row>
              <b-col md="4" class="my-1">
                <b-form-group label-cols-sm="0" label="" class="mb-0">
                  <b-input-group>
                    <b-input-group-append>
                      <b-button @click="search" variant="primary">Buscar</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </template>            
        </b-card-body>   
      </b-card>
      <b-card>
        <b-row>
          <b-col lg="12">
            <c-table @onPageIndexChanged="onPageIndexChanged" :table-data="result" :actionUri="actionUri" :loading="loading" :fields="fields" :customActions="customActions" @onCustomActionClick="onCustomActionClick" striped></c-table>
          </b-col>
        </b-row>
      </b-card>        
      <b-modal
        id="modal-salesperson"
        ref="modal"
        title="Selecionar representante"
        @hidden="resetModal"
        @ok="handleOk"
        ok-title="Salvar"
        cancel-title="Cancelar"
        v-model="showSalesPersonModal">
        <div class="alert alert-danger" role="alert" v-show="salesPersonModel.hasError">{{salesPersonModel.errorMessage}}</div>
        <form ref="form" @submit.stop.prevent="handleSubmit">
          <div class="form-row">
            <div class="col-sm-6">
              <div class="form-group">
                <label>Empresa</label>
                <div>
                  <strong>{{this.salesPersonModel.sellerName}}</strong>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                  <label for="exampleFormControlSelect1">Representante</label>
                  <select :class="{'custom-select': true}" v-model="salesPersonModel.salesPersonId">
                      <option v-for="(s, index) in salesPersonList" :key="index" :value="s.id">
                          {{s.name}}
                      </option>
                  </select>
              </div>
            </div>
          </div>
        </form>
      </b-modal>
      <b-modal
        id="modal-acquirer-settings"
        ref="modal"
        title="Visualizar url adquirente"
        @hidden="resetAcquirerSettingsModal"
        ok-title="Fechar"
        :ok-only="true"
        v-model="showAcquirerSettingsModal"
        size="lg">
        <form ref="form">
          <div class="form-row">
            <div class="col-sm-12">
              <div class="form-group">
                <label>Url de notificação</label>
                <div>
                  <small>{{this.acquirerSettingsModel.endPoint}}</small>
                </div>
              </div>
            </div>
          </div>
        </form>
      </b-modal>
    </div>
</template>
<script>
import cTable from '../../../components/base/Table.vue'
import sellerService from '../../../services/Customer/sellerService'
import contractService from '../../../services/Contracts/contractService'
import salesPersonService from '../../../services/Customer/salesPersonService'
import listPage from '../../../mixins/listPage'
import { ModelListSelect } from 'vue-search-select'
import eventbus from '../../../eventBus'
import config from '../../../config'
export default {
  components: {cTable, ModelListSelect},
  mixins: [listPage],
  data() {
    return {
      actionUri: 'partners/sellers',
      fields: [
        {key: 'name', label: 'Nome', sortable: false},
        {key: 'documentNumber', label: 'Cpf / Cnpj', sortable: false},
        {key: 'email', label: 'E-mail', sortable: false},
        {key: 'contractName', label: 'Contrato', sortable: false},
        {key: 'createdAt', label: 'Criado em', sortable: false},
        {key: 'updatedAt', label: 'Atualizado em', sortable: false},
        {key: 'status', label: 'Status', sortable: false},        
        {key: 'actions', label: ''}
      ],
      customActions: this.getCustomActions(),
      showSalesPersonModal: false,
      salesPersonList:[],
      salesPersonModel: {
        salesPersonId: null,
        sellerId: 0,
        sellerName: '',
        hasError: false,
        errorMessage: ''
      },
      acquirerSettingsModel: {
        endPoint: ''
      },
      partner:{
          username: '',
          token: '',
          endPoint: ''
      },
      showAcquirerSettingsModal: false,
      searchModel: {
        keywords: '',
        salesPerson: {
          selected: 0,
          data: [],
          query: ''
        }
      }
    }
  },
  created() {
    this.bindSalesPersonList()
  },
  methods: {
    getCustomActions() {
      let custom = [];
      custom.push({
        cssClass: 'btn mr-2 btn-md btn-info action-btn',
        html: '<i class="fa fa-code"></i>',
        action: 'getAcquirerUrl'
      });
      
      if(!this.$auth.isSalesPerson)       
      {
        if(config.partnersConfiguration.contracts.exportPdf) {
          custom.unshift({
            cssClass: 'btn mr-2 btn-md btn-info action-btn',
            html: '<i class="fa fa-file"></i>',
            action: 'getContract'
          });
        }
        custom.unshift({
          cssClass: 'btn mr-2 btn-md btn-info action-btn',
          html: '<i class="fa fa-user-plus"></i>',
          action: 'addSalesPerson'
        });
        
      }
      return custom;
    },
    fetchData(page) {
      const self = this
      self.showLoading()
      sellerService.findAll(this.searchModel.keywords, this.searchModel.salesPerson.selected == "0" ? '' : this.searchModel.salesPerson.selected, page).then((response) =>{
        self.$data.result = response.status == 204 ? self.getEmptyResult() : response.data
        self.hideLoading()
      }, (error) =>{
        console.log(error)
        self.hideLoading()
      })      
    },
    bindSalesPersonList() {
      const self = this
      self.showLoading()
      salesPersonService.all('', '').then().then((response) =>{
        self.salesPersonList = response.status == 204 ? [] : response.data
        self.salesPersonList.unshift({id: null, name: 'Nenhum'})
        self.hideLoading()
      }, (error) =>{
        console.log(error)
        self.hideLoading()
      })
    },
    resetModal() {
      this.salesPersonModel.salesPersonId = null
      this.salesPersonModel.sellerId = 0
      this.salesPersonModel.sellerName = ''
      this.salesPersonModel.hasError = false
      this.salesPersonModel.errorMessage = ''
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      this.salesPersonModel.errorMessage = ''
      this.salesPersonModel.hasError = false
      // Trigger submit handler
      this.handleSubmit()
    },
    handleSubmit() {
      const self = this
      sellerService.setSalesPerson(this.salesPersonModel).then((response) => {
        self.fetchData(1)
        // Hide the modal manually
        self.$nextTick(() => {
          self.$refs.modal.hide()
        })
      }, (error) => {
        self.salesPersonModel.errorMessage = 'Ocorreu um erro ao atualizar a empresa.'
        self.salesPersonModel.hasError = true
      })
      
    },
    onCustomActionClick(action, row) {
      if(action == 'addSalesPerson') {
        this.salesPersonModel.sellerId = row.item.id
        this.salesPersonModel.sellerName = row.item.name
        this.salesPersonModel.salesPersonId = row.item.salesPersonId ? row.item.salesPersonId : null
        this.showSalesPersonModal = true
      }
      else if(action == 'getContract') {
        window.open(contractService.getContractUri(row.item.id))
      }
      else if(action == 'getAcquirerUrl') {
        this.acquirerSettingsModel.endPoint = row.item.acquirerSettings.endPoint
        this.showAcquirerSettingsModal = true
      }
    },
    resetAcquirerSettingsModal() {
      this.acquirerSettingsModel.endPoint = ''
    },
    searchSalesPerson(q) {
      if(q != null && q.length < 2)
        return
      const self = this
      eventbus.$emit('ui-action:loading', true)
      salesPersonService.all(q, '').then((response) =>{
        self.searchModel.salesPerson.data = response.status == 204 ? [] : response.data
        eventbus.$emit('ui-action:loading', false)
      }, () =>{
        eventbus.$emit('ui-action:loading', false)
      })
    }
  }
}
</script>
